import React, { useEffect, useRef, useState } from 'react'
import { Paper } from '@mui/material';

import BottomNavigationBar from '../../layouts/BottomNavigationBar'
import { aesEncryptECBHex } from '../../query/QueryAES';

export default function SettingsV2({ account, userId }) {
    const iframeRef = useRef(null);
    const { contype, c_coname } = account

    // useEffect(() => {
    //     setTimeout(() => {
    //         if (iframeRef.current && iframeRef.current.contentWindow) {
    //             iframeRef.current.contentWindow.postMessage(
    //                 { menu: "width", value: "400" },
    //                 "*"
    //             );
    //             console.log('iframeRef', iframeRef)
    //         }
    //     }, 3000);
    // }, []);


    useEffect(() => {
        // ประกาศฟังก์ชันก่อน
        const handleMessage = (event) => {
            if (event.data === "ready") {
                // console.log('Flutter is ready!', event);
                if (iframeRef.current && iframeRef.current.contentWindow) {
                    iframeRef.current.contentWindow.postMessage(
                        { menu: "width", value: "400" },
                        "*"
                    );
                    // console.log('iframeRef', iframeRef)
                }
                // ลบ listener ทันทีหลังได้รับ message
                window.parent.removeEventListener('message', handleMessage);
                // console.log('Flutter listener removed!');
            }
        };

        // เพิ่ม listener
        window.parent.addEventListener('message', handleMessage);
        return () => {
            window.parent.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <div style={{ height: "calc(100vh)", overflow: "hidden" }}>
            <iframe
                ref={iframeRef}
                // src={`http://192.168.95.125:8000/?data=${aesEncryptECBHex(`{"userid":"${userId}","contype":"${contype}","cname":"${c_coname}"}`)}`}
                src={`https://manage.sitgps.com/?data=${aesEncryptECBHex(`{"userid":"${userId}","contype":"${contype}","cname":"${c_coname}"}`)}`}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                title="manage sitgps"
            // onLoad={handleIframeLoad}
            />
            <Paper sx={{ position: 'fixed', width: 400, bottom: 0, left: 0, right: 0, zIndex: 2 }} elevation={3}>
                <BottomNavigationBar ative="settingsv2" />
            </Paper>
        </div>
    )
}
